export { default as Img200 } from './processed/200/Savage-Kingdom-S3.jpg';
export { default as Img400 } from './processed/400/Savage-Kingdom-S3.jpg';
export { default as Imgthumb } from './processed/thumb/Savage-Kingdom-S3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Savage-Kingdom-S3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Savage-Kingdom-S3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      26,
      150,
      229
    ],
    "_population": 0
  },
  "LightVibrant": {
    "_rgb": [
      228,
      214,
      189
    ],
    "_population": 155,
    "_hsl": [
      0.1068376068376068,
      0.41935483870967744,
      0.8176470588235294
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      4,
      23,
      35
    ],
    "_population": 77,
    "_hsl": [
      0.5645161290322581,
      0.7948717948717949,
      0.07647058823529412
    ]
  },
  "Muted": {
    "_rgb": [
      143,
      119,
      86
    ],
    "_population": 1242,
    "_hsl": [
      0.09649122807017545,
      0.2489082969432314,
      0.44901960784313727
    ]
  },
  "LightMuted": {
    "_rgb": [
      198,
      193,
      179
    ],
    "_population": 452,
    "_hsl": [
      0.1228070175438596,
      0.14285714285714296,
      0.7392156862745098
    ]
  },
  "DarkMuted": {
    "_rgb": [
      100,
      76,
      51
    ],
    "_population": 13,
    "_hsl": [
      0.08503401360544217,
      0.32450331125827814,
      0.296078431372549
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Savage-Kingdom-S3.js